import { render, staticRenderFns } from "./MenuTranslator.vue?vue&type=template&id=bf686c98&scoped=true&"
import script from "./MenuTranslator.vue?vue&type=script&lang=js&"
export * from "./MenuTranslator.vue?vue&type=script&lang=js&"
import style0 from "./importer.css?vue&type=style&index=0&id=bf686c98&scoped=true&lang=css&"
import style1 from "./MenuTranslator.vue?vue&type=style&index=1&id=bf686c98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf686c98",
  null
  
)

export default component.exports